import React, { Suspense, useLayoutEffect } from "react";
import "./App.css";
import TubelightNavbar from "./components/globalComponents/navBar/TubelightNavbar";
import ResponsiveFooter from "./components/globalComponents/footer/ResponsiveFooter";
import Spinner from "./components/globalComponents/Spinner";
import PriceActionBootcamp from "./components/priceActionBootcamp/PriceActionBootcamp";
import TradePerformanceCentreAbout from "./components/aboutUs/TradePerformanceCentreAbout";
import TradeFloor from "./components/tradeFloor/TradeFloor";

const HomePage = React.lazy(() => import("./components/homePage/HomePage"));

function App() {
  useLayoutEffect(() => {
    document.getElementById("initial-loader")?.remove();
  }, []);

  const path = window.location.pathname.replace(/\/+$/, "") || "/";

  const renderPage = () => {
    if (path === "/priceActionBootcamp") {
      return <PriceActionBootcamp />;
    }

    if (path === "/tradeFloor") {
      return <TradeFloor />;
    }

    if (path === "/about") {
      return <TradePerformanceCentreAbout />;
    }

    return <HomePage />;
  };

  return (
    <div className="app-shell">
      <TubelightNavbar />
      <main className="app-content">
        <Suspense
          fallback={
            <div className="app-page-loading">
              <Spinner />
            </div>
          }
        >
          {renderPage()}
        </Suspense>
      </main>
      <ResponsiveFooter />
    </div>
  );
}

export default App;
